import { gql } from 'apollo-angular';

const GET_PLAN_IMPACT_IC_GROUP_LEADER = gql`
  query GetPlanImpact($rfpId: Long!) {
    planImpact(rfpId: $rfpId) {
      plannedSpendLevel
      offer {
        id
        name
        unorderedTiers
  			unorderedPricing
        seller {
          name
        }
        tiers {
          id
          name
          description
          cpaId
          order
          allowedPartnerIds
          dollarMarketShare
          unitMarketShare
          absoluteDollars
          absoluteUnits
          spendLevelType
          tierType
          active
        }
      }
      attainability
      selectedTier {
        id
        name
        description
        cpaId
        order
        allowedPartnerIds
        dollarMarketShare
        unitMarketShare
        absoluteDollars
        absoluteUnits
        spendLevelType
        tierType
        active
      }
      planImpacts {
        inclusionStatus
        planId
        member {
          id
          name
          address {
            city
            state
          }
        }
        selectedTier {
          id
          name
          description
          cpaId
          order
          allowedPartnerIds
          dollarMarketShare
          unitMarketShare
          absoluteDollars
          absoluteUnits
          spendLevelType
          tierType
          active
        }
        results {
          savingsAmount
          savingsPct
          plannedSpend
          continuedSpend
          conversionsCount {
            totalConversionsCount
          }
          numberOfIncumbents
          excludedPlannedSpend
          compliancePlannedSpend
        }
      }
    }
  }
`;

export default GET_PLAN_IMPACT_IC_GROUP_LEADER;
